export default __webpack_public_path__ + "static/media/tealbook_logo.a45115b1.jpg";